export const ACTUAL_DOMAIN = 'shef.com';
export const DEPRECATED_DOMAINS = ['myshef.com', 'www.myshef.com'];
export const SHORT_URL_SUBDOMAIN = 'i'; // e.g. i.shef.com/XYZ123
